<div class="form-check form-check-inline">
  <input class="form-check-input" type="radio"
         [id]="identifier" [value]="controlValue" style="background-image: url()"
         [(ngModel)]="value" [checked]="checkedRadio ? 'checked' : ''" [disabled]="disabled">
  <label class="form-check-label" style="cursor: pointer" [for]="identifier">{{ label }}</label>
</div>
